/* eslint-disable react/display-name */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useState} from "react";
import EventsAPI from "../../shared/modules/EventsAPI";
import Helper from "../../shared/modules/Helper";
import PropTypes from "prop-types";
import SearchHistoryAPI from "../Site/components/modules/SearchHistoryAPI";
import {isMobile} from "../../lib/userAgent";

const SearchContainer = (props) => {
  const {focused} = props;
  const [
    searchTerm,
    setSearchTerm
  ] = useState("");

  const [
    recentlySearched,
    setRecentlySearched
  ] = useState([]);

  const [
    popularCollections,
    setPopularCollections
  ] = useState([]);

  const fetchSearchHistories = () => {
    SearchHistoryAPI.getSearchHistoryIndex().then((response) => {
      setRecentlySearched(response.recently_searched);
      setPopularCollections(response.popular_collections);
    });
  };

  const dismissSkeletons = () => {
    const elements = document.querySelectorAll(".search-field-skeleton");

    elements.forEach(element => element.classList.add("opacity-0", "display-none"));
  };

  useEffect(() => {
    document.documentElement.dataset.roxySearchEnabledPage = "true";
    document.documentElement.dataset.showBlurBackdrop = "false";
    document.documentElement.dataset.searchFocused = "false";
    dismissSkeletons();
    window.scrollTo(0, 0);
    if (focused) {
      fetchSearchHistories();
    }
  }, []);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const closeSearch = () => {
    setSearchTerm("");
    document.documentElement.dataset.showBlurBackdrop = "false";
    document.documentElement.dataset.searchFocused = "false";
    document.getElementById("search-container").dataset.focused = "false";
  };

  // NOTE: Placed it here to prevent merge conflicts, should be refactored when finalizing for prod
  useEffect(() => {
    const searchBackdropElement = document.getElementById("blur-backdrop");
    searchBackdropElement.addEventListener("click", closeSearch);
    return () => searchBackdropElement.removeEventListener("click", closeSearch);
  }, []);

  const handleFocus = () => {
    document.documentElement.dataset.showBlurBackdrop = "true";
    document.documentElement.dataset.searchFocused = "true";
    document.getElementById("search-container").dataset.focused = "true";
  };

  const clearSearch = () => {
    setSearchTerm("");
    document.getElementById("search-container").dataset.focused = "true";
  };

  const handleInputClick = () => {
    if (!focused) {
      handleFocus();
    }
  };

  const handleTrackingEventOnClick = (eventName, search) => {
    EventsAPI.trackUserEvent(eventName, `searched_term: ${search}`);
  };

  const getSearchUrl = (search) => {
    const trimmedSearchTerm = search.trim();
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    params.delete("search");
    params.set("search", trimmedSearchTerm);
    const paramsString = Helper.addSearchParamToUrl(params);
    return `${url.pathname}?${paramsString}`;
  };

  const handleSearch = () => {
    handleTrackingEventOnClick("clicked_search_icon", searchTerm);
    const trimmedSearchTerm = searchTerm.trim();
    if (trimmedSearchTerm) {
      SearchHistoryAPI.createSearchHistory({
        "origin_path": window.location.pathname,
        "query": searchTerm
      });

      window.location.href = getSearchUrl(trimmedSearchTerm);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="relative">
      <div
        className={`search-input-container ${focused && isMobile() ? "stretched" : ""}`}
        role="search"
      >
        {focused && (
          <button
            aria-label="close-search"
            className="search-container-back-button -ml-4 flex items-center justify-center px-4 1024:hidden"
            onClick={closeSearch}
            type="button"
          >
            <i className="fa-light fa-chevron-left" />
          </button>
        )}
        <label
          className="sr-only"
          htmlFor="search-input"
          id="search-label"
        >
          Search Rocksbox
        </label>
        <input
          aria-labelledby="search-label"
          className={`search-input-field search-input${focused ? "-focused" : ""}`}
          id="search-input"
          name="search"
          onChange={handleInputChange}
          onClick={handleInputClick}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
          placeholder="Search Rocksbox"
          spellCheck="false"
          type="search"
          value={searchTerm}
        />
        {searchTerm &&
          <div className="search-clear-button-container">
            <button
              aria-label="clear search input field"
              className="search-clear-button clear-button"
              onClick={clearSearch}
              type="button"
            >
              Clear
            </button>
          </div>
        }
        <button
          aria-label={`${focused ? "submit-to-search" : "open-search"}`}
          className="search-button"
          onClick={focused ? handleSearch : handleFocus}
          type="button"
        >
          <i className="fa-light fa-magnifying-glass" />
        </button>
        {focused && (
          <button
            aria-label="close-search"
            className="search-container-close-button display-hidden 1024:flex items-center justify-center px-4"
            onClick={closeSearch}
            type="button"
          >
            <i className="fa-light fa-xmark" />
          </button>
        )}
      </div>
      {focused && (
        <div className={`search-info-container pt-8 flex flex-col gap-8 lg:flex-row w-full ${isMobile() ? "mobile" : "desktop"}`}>
          {recentlySearched.length > 0 && (
            <div className="recently-searched search-info-section">
              <div className="font-serif text-xl border-b border-neutral-400 pb-2">
                Recently Searched
              </div>
              <div className="flex flex-wrap pt-2 gap-2">
                {recentlySearched.map(search => (
                  <a
                    className="button-pill"
                    href={getSearchUrl(search)}
                    key={`search-${search.replace(/ /g, "-").toLowerCase()}`}
                    onClick={() => handleTrackingEventOnClick("clicked_recently_searched_link", search)}
                  >
                    {search}
                  </a>
                ))}
              </div>
            </div>)}
          {popularCollections.length > 0 && (
            <div className="popular-collection space-y-4 search-info-section">
              <div className="font-serif text-xl border-b border-neutral-400 pb-2">
                Popular Collections
              </div>
              <div className="flex flex-col">
                {popularCollections.map(collection => (
                  <a
                    className="inline-flex text-lg font-sans leading-[18px] py-2 capitalize"
                    href={collection.link_url}
                    key={`collection-${collection.page_name}`}
                    onClick={() => handleTrackingEventOnClick("clicked_popular_collections_link", collection)}
                  >
                    {collection.page_name}
                  </a>
                ))}
              </div>
            </div>)}
        </div>
      )}
    </div>
  );
};

SearchContainer.propTypes = {"focused": PropTypes.bool};

SearchContainer.defaultProps = {"focused": false};

export default props => <SearchContainer {...props} />;
